import { VCard } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';

var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fadeInUp"}},[_c(VDialog,{staticClass:"image_modal",on:{"click:outside":_vm.toggleModal},model:{value:(_vm.modalIsOpen),callback:function ($$v) {_vm.modalIsOpen=$$v},expression:"modalIsOpen"}},[_c(VCard,[_c('img',{attrs:{"src":_vm.modalImage,"alt":"Modal Image","width":"250","height":"250"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }